import React, { Component } from 'react';
import RValueField from './rvaluefield.component';
import RadioSet from '../radioset/radioset.component';
import applyLogic from '../util/applyLogic';
// import { glazing2009StandardsWarning } from '../validation/validationhelpers';

import './rvaluefield.scss';

const ConditionalField = ({ show, children }) => {
    return show ? children : null;
};

export default class RadioRValueField extends Component {
    render() {
        const {
                label,
                name,
                radioField,
                rvalueFields,
                formValues,
                extra
            } = this.props,
            descriptionText = extra && extra.description ? extra.description() : null;

        return (
            <div className='ht-field ht-radiorvaluefield'>
                {label && (
                    <label
                        htmlFor={name}
                        className='bx--label ht-radiorvaluefield-label'
                    >
                        {label}
                    </label>
                )}
                {descriptionText && (
                    <div className='bx--form__helper-text ht-radiorvaluefield-description'>
                        {descriptionText}
                    </div>
                )}
                <div className='ht-radiorvaluefield-radio'>
                    <RadioSet
                        errors={radioField.errors}
                        {...radioField.bind()}
                        {...radioField.get('extra')}
                        description={false}
                        // warning={radioField.warning} // <--- this
                        inline
                    />
                </div>

                <div className='ht-radiorvaluefield-rvalue'>
                    {rvalueFields.map(rvalueField => {
                        const show = applyLogic(
                            rvalueField.extra.showIf,
                            formValues
                        );

                        return (
                            <ConditionalField
                                key={rvalueField.name}
                                show={show}
                            >
                                <RValueField
                                    field={rvalueField}
                                    errors={rvalueField.errors}
                                    {...rvalueField.bind()}
                                    {...rvalueField.get('extra')}
                                    description={false}
                                />
                            </ConditionalField>
                        );
                    })}
                </div>
            </div>
        );
    }
}
